// src/pages/CategoryManagement.js
import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';

const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [globalAttributes, setGlobalAttributes] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const [isAttrLoading, setIsAttrLoading] = useState(false);
  const [isMainLoading, setIsMainLoading] = useState(false);
  const [isSubLoading, setIsSubLoading] = useState(false);

  const [homeConfig, setHomeConfig] = useState(null);
  const [isHomeLoading, setIsHomeLoading] = useState(false);

  const [homeThemeDarkBg, setHomeThemeDarkBg] = useState('#4C1D95');
  const [homeThemeLightBg, setHomeThemeLightBg] = useState('#F3E8FF');
  const [homeThemeTopText, setHomeThemeTopText] = useState('#FFFFFF');
  const [homeThemeBottomText, setHomeThemeBottomText] = useState('#0F172A');
  const [homeTopImage, setHomeTopImage] = useState(null);
  const [homeBannerImage, setHomeBannerImage] = useState(null);
  const [homeIcon, setHomeIcon] = useState(null);

  const [homeMainCategories, setHomeMainCategories] = useState([]);
  const [homeSubCategories, setHomeSubCategories] = useState({});

  const [homeCategoryStyle, setHomeCategoryStyle] = useState('home_style_1');
  const [removeHomeTopImage, setRemoveHomeTopImage] = useState(false);
  const [removeHomeBannerImage, setRemoveHomeBannerImage] = useState(false);
  const [homeSectionBg, setHomeSectionBg] = useState('#111827');
  const [homeCardBg, setHomeCardBg] = useState('#1F2937');
  const [homeTextColor, setHomeTextColor] = useState('#FFFFFF');
  const [homeAccentColor, setHomeAccentColor] = useState('#FBBF24');


  const [attrName, setAttrName] = useState('');

  // Main Category States
  const [name, setName] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const [topImage, setTopImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);

  const [themeDarkBg, setThemeDarkBg] = useState('#4C1D95');
  const [themeLightBg, setThemeLightBg] = useState('#F3E8FF');
  const [themeTopText, setThemeTopText] = useState('#FFFFFF');
  const [themeBottomText, setThemeBottomText] = useState('#0F172A');
  const [subCategorySectionBg, setSubCategorySectionBg] = useState('#FFFFFF');
  const [subCategoryCardBg, setSubCategoryCardBg] = useState('#F8FAFC');
  const [subCategoryTextColor, setSubCategoryTextColor] = useState('#334155');
  const [subCategoryAccentColor, setSubCategoryAccentColor] = useState('#E11D48');

  // HEADING & UI STATES
  const [subCategoryStyle, setSubCategoryStyle] = useState('style_4');
  const [headingAlignment, setHeadingAlignment] = useState('left');
  const [headingTopText, setHeadingTopText] = useState('DISCOVER');
  const [headingTopColor, setHeadingTopColor] = useState('#94A3B8');
  const [headingMainText, setHeadingMainText] = useState('Explore Products');
  const [headingMainColor, setHeadingMainColor] = useState('#0F172A');

  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [subCatName, setSubCatName] = useState('');
  const [subCatImage, setSubCatImage] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);

  const [editModal, setEditModal] = useState({ isOpen: false, type: '', data: null });
  const [editData, setEditData] = useState({
    name: '', image: null, topImage: null, bannerImage: null,
    currentImage: '', currentTopImage: '', currentBannerImage: '',
    removeTopImage: false, removeBannerImage: false, // 🔥 FLAGS TO REMOVE IMAGES
    attributes: [],
    themeDarkBg: '', themeLightBg: '', themeTopText: '', themeBottomText: '',
    subCategoryStyle: '', headingAlignment: '', headingTopText: '', headingTopColor: '', headingMainText: '', headingMainColor: '',
    subCategorySectionBg: '', subCategoryCardBg: '', subCategoryTextColor: '', subCategoryAccentColor: ''
  });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const [catRes, attrRes, homeRes] = await Promise.all([
        apiClient.get('/categories/all'),
        apiClient.get('/categories/attributes'),
        apiClient.get('/home-config')
      ]);

      setCategories(catRes.data.categories || []);
      setGlobalAttributes(attrRes.data.attributes || []);

      if (homeRes.data?.success && homeRes.data.homeConfig) {
        const home = homeRes.data.homeConfig;
        setHomeConfig(home);
        setHomeSectionBg(home.homeSectionBg || '#111827');
        setHomeCardBg(home.homeCardBg || '#1F2937');
        setHomeTextColor(home.homeTextColor || '#FFFFFF');
        setHomeAccentColor(home.homeAccentColor || '#FBBF24');

        setHomeThemeDarkBg(home.themeDarkBg || '#4C1D95');
        setHomeThemeLightBg(home.themeLightBg || '#F3E8FF');
        setHomeThemeTopText(home.themeTopText || '#FFFFFF');
        setHomeThemeBottomText(home.themeBottomText || '#0F172A');
        setHomeCategoryStyle(home.homeCategoryStyle || 'home_style_1');

        setHomeMainCategories(
          (home.homeMainCategories || []).map(cat =>
            typeof cat === 'string' ? cat : cat._id
          )
        );

        let subMap = {};

        (home.homeSubCategories || []).forEach(item => {
          subMap[item.mainCategoryId] = item.subCategoryIds || [];
        });

        setHomeSubCategories(subMap);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleAddAttribute = async (e) => {
    e.preventDefault(); if (!attrName) return;
    setIsAttrLoading(true);
    try { await apiClient.post('/categories/add-attribute', { name: attrName }); setAttrName(''); fetchData(); }
    catch (e) { alert("Error adding"); } finally { setIsAttrLoading(false); }
  };

  const handleAddMainCategory = async (e) => {
    e.preventDefault(); if (!name || !mainImage) return;
    setIsMainLoading(true);
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('image', mainImage);
      if (topImage) formData.append('topImage', topImage);
      if (bannerImage) formData.append('bannerImage', bannerImage);

      formData.append('themeDarkBg', themeDarkBg);
      formData.append('themeLightBg', themeLightBg);
      formData.append('themeTopText', themeTopText);
      formData.append('themeBottomText', themeBottomText);

      formData.append('subCategoryStyle', subCategoryStyle);
      formData.append('headingAlignment', headingAlignment);
      formData.append('headingTopText', headingTopText);
      formData.append('headingTopColor', headingTopColor);
      formData.append('headingMainText', headingMainText);
      formData.append('headingMainColor', headingMainColor);
      formData.append('subCategorySectionBg', subCategorySectionBg);
      formData.append('subCategoryCardBg', subCategoryCardBg);
      formData.append('subCategoryTextColor', subCategoryTextColor);
      formData.append('subCategoryAccentColor', subCategoryAccentColor);

      await apiClient.post('/categories/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

      setName(''); setMainImage(null); setTopImage(null); setBannerImage(null);
      setThemeDarkBg('#4C1D95'); setThemeLightBg('#F3E8FF');
      setThemeTopText('#FFFFFF'); setThemeBottomText('#0F172A');
      setSubCategoryStyle('style_4'); setHeadingAlignment('left');
      setHeadingTopText('DISCOVER'); setHeadingTopColor('#94A3B8');
      setHeadingMainText('Explore Products'); setHeadingMainColor('#0F172A');
      setSubCategorySectionBg('#FFFFFF');
      setSubCategoryCardBg('#F8FAFC');
      setSubCategoryTextColor('#334155');
      setSubCategoryAccentColor('#E11D48');

      document.getElementById('mainImageInput').value = '';
      const topImgInput = document.getElementById('topImageInput');
      if (topImgInput) topImgInput.value = '';
      const bannerImgInput = document.getElementById('bannerImageInput');
      if (bannerImgInput) bannerImgInput.value = '';

      fetchData();
    } catch (e) { alert("Error adding"); } finally { setIsMainLoading(false); }
  };

  const handleHomeMainCategoryToggle = (catId) => {
    if (homeMainCategories.includes(catId)) {

      setHomeMainCategories(
        homeMainCategories.filter(id => id !== catId)
      );

      let updatedSubs = { ...homeSubCategories };
      delete updatedSubs[catId];

      setHomeSubCategories(updatedSubs);

    } else {

      setHomeMainCategories([
        ...homeMainCategories,
        catId
      ]);

    }
  };

  const handleHomeSubCategoryToggle = (mainCatId, subCatId) => {

    const currentSubs = homeSubCategories[mainCatId] || [];

    if (currentSubs.includes(subCatId)) {

      setHomeSubCategories({
        ...homeSubCategories,
        [mainCatId]: currentSubs.filter(id => id !== subCatId)
      });

    } else {

      setHomeSubCategories({
        ...homeSubCategories,
        [mainCatId]: [...currentSubs, subCatId]
      });

    }
  };

  const handleUpdateHomeConfig = async (e) => {
    e.preventDefault();
    setIsHomeLoading(true);

    try {
      const formData = new FormData();

      formData.append('themeDarkBg', homeThemeDarkBg);
      formData.append('themeLightBg', homeThemeLightBg);
      formData.append('themeTopText', homeThemeTopText);
      formData.append('themeBottomText', homeThemeBottomText);
      formData.append('homeCategoryStyle', homeCategoryStyle);
      formData.append('homeSectionBg', homeSectionBg);
      formData.append('homeCardBg', homeCardBg);
      formData.append('homeTextColor', homeTextColor);
      formData.append('homeAccentColor', homeAccentColor);
      formData.append(
        'homeMainCategories',
        JSON.stringify(homeMainCategories)
      );

      const formattedSubCats = Object.keys(homeSubCategories).map(mainId => ({
        mainCategoryId: mainId,
        subCategoryIds: homeSubCategories[mainId]
      }));

      formData.append(
        'homeSubCategories',
        JSON.stringify(formattedSubCats)
      );
      if (removeHomeTopImage) formData.append('removeTopImage', 'true');
      if (removeHomeBannerImage) formData.append('removeBannerImage', 'true');

      if (homeTopImage) formData.append('topImage', homeTopImage);

if (homeBannerImage)
  formData.append('bannerImage', homeBannerImage);

if (homeIcon)
  formData.append('homeIcon', homeIcon);

      await apiClient.put('/home-config', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setHomeTopImage(null);
      setHomeBannerImage(null);
      setRemoveHomeTopImage(false);
      setRemoveHomeBannerImage(false);

      const topInput = document.getElementById('homeTopImageInput');
      if (topInput) topInput.value = '';

      const bannerInput = document.getElementById('homeBannerImageInput');
      if (bannerInput) bannerInput.value = '';

      alert('Home page config updated successfully!');
      fetchData();
    } catch (error) {
      console.error(error);
      alert('Home config update failed');
    } finally {
      setIsHomeLoading(false);
    }
  };

  const handleAddSubCategory = async (e) => {
    e.preventDefault(); if (!selectedCategoryId || !subCatName || !subCatImage) return;
    setIsSubLoading(true);
    try {
      const formData = new FormData(); formData.append('categoryId', selectedCategoryId); formData.append('subCatName', subCatName); formData.append('subImage', subCatImage); formData.append('selectedAttributes', JSON.stringify(selectedAttributes));
      await apiClient.post('/categories/add-subcategory', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSubCatName(''); setSubCatImage(null); setSelectedAttributes([]); document.getElementById('subCatImageInput').value = ''; fetchData();
    } catch (e) { alert("Error adding"); } finally { setIsSubLoading(false); }
  };

  const handleCheckboxChange = (attrName, isEdit = false) => {
    if (isEdit) {
      const currentAttrs = editData.attributes || [];
      if (currentAttrs.includes(attrName)) setEditData({ ...editData, attributes: currentAttrs.filter(a => a !== attrName) });
      else setEditData({ ...editData, attributes: [...currentAttrs, attrName] });
    } else {
      if (selectedAttributes.includes(attrName)) setSelectedAttributes(selectedAttributes.filter(a => a !== attrName));
      else setSelectedAttributes([...selectedAttributes, attrName]);
    }
  };

  const handleDeleteAttribute = async (id) => { if (window.confirm('Delete this attribute?')) { await apiClient.delete(`/categories/attribute/${id}`); fetchData(); } };
  const handleDeleteMainCategory = async (id) => { if (window.confirm('Delete Main Category and all its subs?')) { await apiClient.delete(`/categories/main/${id}`); fetchData(); } };
  const handleDeleteSubCategory = async (catId, subId) => { if (window.confirm('Delete Sub Category?')) { await apiClient.delete(`/categories/sub/${catId}/${subId}`); fetchData(); } };

  const openEditModal = (type, data) => {
    setEditModal({ isOpen: true, type, data });
    if (type === 'attribute') setEditData({ name: data.name });

    if (type === 'main') setEditData({
      name: data.name,
      image: null,
      topImage: null,
      bannerImage: null,
      currentImage: data.image,
      currentTopImage: data.themeTopImage,
      currentBannerImage: data.bannerImage,
      removeTopImage: false,
      removeBannerImage: false,
      themeDarkBg: data.themeDarkBg || '#4C1D95',
      themeLightBg: data.themeLightBg || '#F3E8FF',
      themeTopText: data.themeTopText || '#FFFFFF',
      themeBottomText: data.themeBottomText || '#0F172A',
      subCategoryStyle: data.subCategoryStyle || 'style_4',
      headingAlignment: data.headingAlignment || 'left',
      headingTopText: data.headingTopText || 'DISCOVER',
      headingTopColor: data.headingTopColor || '#94A3B8',
      headingMainText: data.headingMainText || 'Explore Products',
      headingMainColor: data.headingMainColor || '#0F172A',
      subCategorySectionBg: data.subCategorySectionBg || '#FFFFFF',
      subCategoryCardBg: data.subCategoryCardBg || '#F8FAFC',
      subCategoryTextColor: data.subCategoryTextColor || '#334155',
      subCategoryAccentColor: data.subCategoryAccentColor || '#E11D48'
    });

    if (type === 'sub') setEditData({
      name: data.name,
      image: null,
      currentImage: data.image,
      attributes: data.attributes || []
    });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editModal.type === 'attribute') {
        await apiClient.put(`/categories/attribute/${editModal.data._id}`, { name: editData.name });
      } else if (editModal.type === 'main') {
        const formData = new FormData();
        formData.append('name', editData.name);
        formData.append('themeDarkBg', editData.themeDarkBg);
        formData.append('themeLightBg', editData.themeLightBg);
        formData.append('themeTopText', editData.themeTopText);
        formData.append('themeBottomText', editData.themeBottomText);

        formData.append('subCategoryStyle', editData.subCategoryStyle);
        formData.append('headingAlignment', editData.headingAlignment);
        formData.append('headingTopText', editData.headingTopText);
        formData.append('headingTopColor', editData.headingTopColor);
        formData.append('headingMainText', editData.headingMainText);
        formData.append('headingMainColor', editData.headingMainColor);
        formData.append('subCategorySectionBg', editData.subCategorySectionBg);
        formData.append('subCategoryCardBg', editData.subCategoryCardBg);
        formData.append('subCategoryTextColor', editData.subCategoryTextColor);
        formData.append('subCategoryAccentColor', editData.subCategoryAccentColor);

        // Send flags if user removed images
        if (editData.removeTopImage) formData.append('removeTopImage', 'true');
        if (editData.removeBannerImage) formData.append('removeBannerImage', 'true');

        if (editData.image) formData.append('image', editData.image);
        if (editData.topImage) formData.append('topImage', editData.topImage);
        if (editData.bannerImage) formData.append('bannerImage', editData.bannerImage);

        await apiClient.put(`/categories/main/${editModal.data._id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      } else if (editModal.type === 'sub') {
        const formData = new FormData(); formData.append('subCatName', editData.name);
        formData.append('selectedAttributes', JSON.stringify(editData.attributes));
        if (editData.image) formData.append('subImage', editData.image);
        await apiClient.put(`/categories/sub/${editModal.data.categoryId}/${editModal.data._id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      setEditModal({ isOpen: false, type: '', data: null }); fetchData();
    } catch (error) { alert("Failed to update."); }
  };

  const totalSubCats = categories.reduce((acc, cat) => acc + (cat.subCategories?.length || 0), 0);

  return (
    <div className="categories-content" style={{ position: 'relative' }}>

      {editModal.isOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(27,37,75,0.7)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)' }}>
          <div style={{ background: '#fff', padding: '30px', borderRadius: '20px', width: '90%', maxWidth: '600px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 className="table-title" style={{ marginBottom: '20px' }}>Edit {editModal.type === 'attribute' ? 'Attribute' : editModal.type === 'main' ? 'Main Category' : 'Sub-Category'}</h2>
            <form onSubmit={handleEditSubmit}>
              <div className="form-group"><label className="form-label">Name</label><input type="text" className="modern-input" value={editData.name} onChange={(e) => setEditData({ ...editData, name: e.target.value })} required /></div>

              {(editModal.type === 'main' || editModal.type === 'sub') && (
                <div className="form-group">
                  <label className="form-label">Update Icon Image</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {editData.currentImage && (
                      <img src={`https://pickupdrop.dodigitals.in/${editData.currentImage}`} alt="Current" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #e2e8f0' }} />
                    )}
                    <input type="file" className="modern-input" style={{ flex: 1, marginBottom: 0 }} onChange={(e) => setEditData({ ...editData, image: e.target.files[0] })} accept="image/*" />
                  </div>
                </div>
              )}

              {editModal.type === 'main' && (
                <>
                  <div className="form-group">
                    <label className="form-label">Update Theme BG Image</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {editData.currentTopImage && !editData.removeTopImage && (
                        <div style={{ position: 'relative' }}>
                          <img src={`https://pickupdrop.dodigitals.in/${editData.currentTopImage}`} alt="Current Top BG" style={{ width: '60px', height: '40px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #e2e8f0' }} />
                          {/* 🔥 Image Hataane wala 'X' Button 🔥 */}
                          <button type="button" onClick={() => setEditData({ ...editData, removeTopImage: true })} style={{ position: 'absolute', top: -5, right: -5, background: '#ef4444', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', padding: 0 }}>✕</button>
                        </div>
                      )}
                      <input type="file" className="modern-input" style={{ flex: 1, marginBottom: 0 }} onChange={(e) => setEditData({ ...editData, topImage: e.target.files[0], removeTopImage: false })} accept="image/*" />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Update UI Banner Image</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {editData.currentBannerImage && !editData.removeBannerImage && (
                        <div style={{ position: 'relative' }}>
                          <img src={`https://pickupdrop.dodigitals.in/${editData.currentBannerImage}`} alt="Current Banner" style={{ width: '60px', height: '40px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #e2e8f0' }} />
                          {/* 🔥 Image Hataane wala 'X' Button 🔥 */}
                          <button type="button" onClick={() => setEditData({ ...editData, removeBannerImage: true })} style={{ position: 'absolute', top: -5, right: -5, background: '#ef4444', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', padding: 0 }}>✕</button>
                        </div>
                      )}
                      <input type="file" className="modern-input" style={{ flex: 1, marginBottom: 0 }} onChange={(e) => setEditData({ ...editData, bannerImage: e.target.files[0], removeBannerImage: false })} accept="image/*" />
                    </div>
                  </div>

                  {/* 🔥 FIX: Missing Colors Wapas add kiye 🔥 */}
                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Top BG Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.themeDarkBg} onChange={(e) => setEditData({ ...editData, themeDarkBg: e.target.value })} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Top Text Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.themeTopText} onChange={(e) => setEditData({ ...editData, themeTopText: e.target.value })} />
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Bottom BG Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.themeLightBg} onChange={(e) => setEditData({ ...editData, themeLightBg: e.target.value })} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Bottom Text Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.themeBottomText} onChange={(e) => setEditData({ ...editData, themeBottomText: e.target.value })} />
                    </div>
                  </div>

                  <h4 style={{ marginTop: '20px', marginBottom: '10px', color: '#1E293B', borderBottom: '1px solid #E2E8F0', paddingBottom: '5px' }}>Heading & Style Configuration</h4>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Section BG</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.subCategorySectionBg} onChange={(e) => setEditData({ ...editData, subCategorySectionBg: e.target.value })} />
                    </div>

                    <div style={{ flex: 1 }}>
                      <label className="form-label">Card BG</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.subCategoryCardBg} onChange={(e) => setEditData({ ...editData, subCategoryCardBg: e.target.value })} />
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Text Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.subCategoryTextColor} onChange={(e) => setEditData({ ...editData, subCategoryTextColor: e.target.value })} />
                    </div>

                    <div style={{ flex: 1 }}>
                      <label className="form-label">Accent Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.subCategoryAccentColor} onChange={(e) => setEditData({ ...editData, subCategoryAccentColor: e.target.value })} />
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Card Style</label>
                      <select className="modern-input" value={editData.subCategoryStyle} onChange={(e) => setEditData({ ...editData, subCategoryStyle: e.target.value })}>
                        <option value="style_1">Style 1 (Fashion Circles)</option>
                        <option value="style_2">Style 2 (Beauty Wide)</option>
                        <option value="style_4">Style 4 (Fresh Square)</option>
                        <option value="style_5">Style 5 (Pharma Grey)</option>
                        <option value="style_7">Style 7 (Pills)</option>
                        <option value="style_8">Style 8 (Tall Portrait)</option>
                        <option value="style_10">Style 10 (Minimal Outline)</option>
                        <option value="style_21">Style 21 (Polaroid)</option>
                        <option value="style_29">Style 29 (Coupon)</option>
                        <option value="style_34">Style 34 (Chat Bubble)</option>
                      </select>
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Text Alignment</label>
                      <select className="modern-input" value={editData.headingAlignment} onChange={(e) => setEditData({ ...editData, headingAlignment: e.target.value })}>
                        <option value="left">Left</option>
                        <option value="center">Center</option>
                        <option value="right">Right</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 2 }}>
                      <label className="form-label">Top Text (e.g. DISCOVER)</label>
                      <input type="text" className="modern-input" value={editData.headingTopText} onChange={(e) => setEditData({ ...editData, headingTopText: e.target.value })} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.headingTopColor} onChange={(e) => setEditData({ ...editData, headingTopColor: e.target.value })} />
                    </div>
                  </div>

                  <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 2 }}>
                      <label className="form-label">Main Title Text</label>
                      <input type="text" className="modern-input" value={editData.headingMainText} onChange={(e) => setEditData({ ...editData, headingMainText: e.target.value })} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Color</label>
                      <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={editData.headingMainColor} onChange={(e) => setEditData({ ...editData, headingMainColor: e.target.value })} />
                    </div>
                  </div>
                </>
              )}

              {editModal.type === 'sub' && (
                <div className="form-group">
                  <label className="form-label">Update Attributes</label>
                  <div className="pd-pill-checkboxes" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                    {globalAttributes.map(attr => (
                      <label key={attr._id} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', background: '#fff', padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <input type="checkbox" checked={(editData.attributes || []).includes(attr.name)} onChange={() => handleCheckboxChange(attr.name, true)} /> {attr.name}
                      </label>
                    ))}
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', gap: '15px', marginTop: '25px' }}>
                <button type="button" onClick={() => setEditModal({ isOpen: false, type: '', data: null })} style={{ flex: 1, padding: '14px', borderRadius: '12px', border: '1px solid #e2e8f0', background: '#f4f7fe', color: '#1b254b', fontWeight: 'bold' }}>Cancel</button>
                <button type="submit" className="modern-btn" style={{ flex: 1, margin: 0 }}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="page-header">
        <div><h1 className="page-title">Catalog Master</h1><p className="page-desc">Manage your complete product taxonomy visually.</p></div>
      </div>

      <div className="pd-stats-row">
        <div className="pd-stat-box blue-line"><div className="pd-stat-info"><h4>Main Categories</h4><h2>{categories.length}</h2></div><div className="pd-stat-icon">📦</div></div>
        <div className="pd-stat-box orange-line"><div className="pd-stat-info"><h4>Sub Categories</h4><h2>{totalSubCats}</h2></div><div className="pd-stat-icon">🛍️</div></div>
        <div className="pd-stat-box green-line"><div className="pd-stat-info"><h4>Global Attributes</h4><h2>{globalAttributes.length}</h2></div><div className="pd-stat-icon">🏷️</div></div>
      </div>

      <div className="pd-master-grid">
        <div>
          <div className="pd-form-widget">
            <h3 className="pd-widget-title">🏷️ Global Attributes</h3>
            <form onSubmit={handleAddAttribute} style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
              <input type="text" className="modern-input" style={{ marginBottom: 0 }} value={attrName} onChange={(e) => setAttrName(e.target.value)} placeholder="e.g. Size, Color" />
              <button type="submit" disabled={isAttrLoading} className="modern-btn" style={{ width: 'auto', margin: 0, padding: '0 25px', background: 'var(--brand-blue)' }}>Add</button>
            </form>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {globalAttributes.map(attr => (
                <span key={attr._id} style={{ background: '#f4f7fe', color: 'var(--brand-blue)', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span onClick={() => openEditModal('attribute', attr)} style={{ cursor: 'pointer' }}>✏️</span>{attr.name}
                  <span onClick={() => handleDeleteAttribute(attr._id)} style={{ color: 'var(--brand-orange)', cursor: 'pointer', fontSize: '16px' }}>×</span>
                </span>
              ))}
            </div>
          </div>

          <div className="pd-form-widget">
            <h3 className="pd-widget-title">🏠 Home Page Config</h3>

            <form onSubmit={handleUpdateHomeConfig}>
              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Top BG Color</label>
                  <input
                    type="color"
                    className="modern-input"
                    style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }}
                    value={homeThemeDarkBg}
                    onChange={(e) => setHomeThemeDarkBg(e.target.value)}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Top Text Color</label>
                  <input
                    type="color"
                    className="modern-input"
                    style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }}
                    value={homeThemeTopText}
                    onChange={(e) => setHomeThemeTopText(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Bottom BG Color</label>
                  <input
                    type="color"
                    className="modern-input"
                    style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }}
                    value={homeThemeLightBg}
                    onChange={(e) => setHomeThemeLightBg(e.target.value)}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Bottom Text Color</label>
                  <input
                    type="color"
                    className="modern-input"
                    style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }}
                    value={homeThemeBottomText}
                    onChange={(e) => setHomeThemeBottomText(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Section BG</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={homeSectionBg} onChange={(e) => setHomeSectionBg(e.target.value)} />
                </div>

                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Card BG</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={homeCardBg} onChange={(e) => setHomeCardBg(e.target.value)} />
                </div>
              </div>

              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Text Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={homeTextColor} onChange={(e) => setHomeTextColor(e.target.value)} />
                </div>

                <div style={{ flex: 1 }}>
                  <label className="form-label">Home Accent Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={homeAccentColor} onChange={(e) => setHomeAccentColor(e.target.value)} />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Home Category Design</label>
                <select
                  className="modern-input"
                  value={homeCategoryStyle}
                  onChange={(e) => setHomeCategoryStyle(e.target.value)}
                >
                  <option value="home_style_1">Home Style 1</option>
                  <option value="home_style_2">Home Style 2</option>
                  <option value="home_style_3">Home Style 3</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Home Theme Background Image</label>

                {homeConfig?.themeTopImage && !removeHomeTopImage && (
                  <div style={{ position: 'relative', marginBottom: '8px' }}>
                    <img
                      src={`https://pickupdrop.dodigitals.in/${homeConfig.themeTopImage}`}
                      alt="Home Theme"
                      style={{ width: '100%', height: '70px', objectFit: 'cover', borderRadius: '10px' }}
                    />
                    <button
                      type="button"
                      onClick={() => setRemoveHomeTopImage(true)}
                      style={{
                        position: 'absolute',
                        top: '6px',
                        right: '6px',
                        background: '#ef4444',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}

                <input
                  type="file"
                  id="homeTopImageInput"
                  className="modern-input"
                  accept="image/*"
                  onChange={(e) => setHomeTopImage(e.target.files[0])}
                  style={{ padding: '10px' }}
                />
              </div>
<div className="form-group">
                  <label className="form-label">Home Icon</label>

                  {homeConfig?.homeIcon && (
                    <div style={{ marginBottom: '10px' }}>
                      <img
                        src={`https://pickupdrop.dodigitals.in/${homeConfig.homeIcon}`}
                        alt="Home Icon"
                        style={{
                          width: '60px',
                          height: '60px',
                          borderRadius: '12px',
                          objectFit: 'cover',
                          border: '1px solid #E2E8F0'
                        }}
                      />
                    </div>
                  )}

                  <input
                    type="file"
                    className="modern-input"
                    accept="image/*"
                    onChange={(e) => setHomeIcon(e.target.files[0])}
                    style={{ padding: '10px' }}
                  />
                </div>
              <div className="form-group">
                <label className="form-label">Home Banner Image</label>

                {homeConfig?.bannerImage && !removeHomeBannerImage && (
                  <div style={{ position: 'relative', marginBottom: '8px' }}>
                    <img
                      src={`https://pickupdrop.dodigitals.in/${homeConfig.bannerImage}`}
                      alt="Home Banner"
                      style={{ width: '100%', height: '90px', objectFit: 'cover', borderRadius: '10px' }}
                    />
                    <button
                      type="button"
                      onClick={() => setRemoveHomeBannerImage(true)}
                      style={{
                        position: 'absolute',
                        top: '6px',
                        right: '6px',
                        background: '#ef4444',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}

                <input
                  type="file"
                  id="homeBannerImageInput"
                  className="modern-input"
                  accept="image/*"
                  onChange={(e) => setHomeBannerImage(e.target.files[0])}
                  style={{ padding: '10px' }}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Select Categories For Home</label>

                <div className="pd-pill-checkboxes" style={{ maxHeight: '350px', overflowY: 'auto' }}>

                  {categories.map(cat => {

                    const isSelected = homeMainCategories.includes(cat._id);

                    return (
                      <div
                        key={cat._id}
                        style={{
                          border: '1px solid #E2E8F0',
                          borderRadius: '12px',
                          padding: '10px',
                          marginBottom: '10px',
                          background: '#fff'
                        }}
                      >

                        {/* MAIN CATEGORY */}

                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: '700'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleHomeMainCategoryToggle(cat._id)}
                          />

                          {cat.image && (
                            <img
                              src={`https://pickupdrop.dodigitals.in/${cat.image}`}
                              alt={cat.name}
                              style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '8px',
                                objectFit: 'cover'
                              }}
                            />
                          )}

                          {cat.name}
                        </label>

                        {/* SUB CATEGORIES */}

                        {isSelected && cat.subCategories?.length > 0 && (

                          <div
                            style={{
                              marginTop: '12px',
                              paddingLeft: '20px',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px'
                            }}
                          >

                            {cat.subCategories.map(sub => {

                              const checked =
                                homeSubCategories[cat._id]?.includes(sub._id);

                              return (
                                <label
                                  key={sub._id}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    fontSize: '13px'
                                  }}
                                >

                                  <input
                                    type="checkbox"
                                    checked={checked || false}
                                    onChange={() =>
                                      handleHomeSubCategoryToggle(cat._id, sub._id)
                                    }
                                  />

                                  <img
                                    src={`https://pickupdrop.dodigitals.in/${sub.image}`}
                                    alt={sub.name}
                                    style={{
                                      width: '22px',
                                      height: '22px',
                                      borderRadius: '6px',
                                      objectFit: 'cover'
                                    }}
                                  />

                                  {sub.name}

                                </label>
                              );

                            })}

                          </div>

                        )}

                      </div>
                    );

                  })}

                </div>
              </div>

              <button
                type="submit"
                disabled={isHomeLoading}
                className="modern-btn"
                style={{ background: '#7C3AED' }}
              >
                {isHomeLoading ? 'Saving Home...' : 'Save Home Config'}
              </button>
            </form>
          </div>

          <div className="pd-form-widget">
            <h3 className="pd-widget-title">📦 Add Main Category</h3>
            <form onSubmit={handleAddMainCategory}>
              <div className="form-group"><label className="form-label">Name</label><input type="text" className="modern-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Electronics" /></div>

              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Top BG Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={themeDarkBg} onChange={(e) => setThemeDarkBg(e.target.value)} />
                </div>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Top Text Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={themeTopText} onChange={(e) => setThemeTopText(e.target.value)} />
                </div>
              </div>

              {/* Bottom Colors in Add Form */}
              <div className="form-group" style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Bottom BG Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={themeLightBg} onChange={(e) => setThemeLightBg(e.target.value)} />
                </div>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Bottom Text Color</label>
                  <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={themeBottomText} onChange={(e) => setThemeBottomText(e.target.value)} />
                </div>
              </div>

              <div style={{ background: '#F8FAFC', padding: '15px', borderRadius: '12px', marginBottom: '15px', border: '1px solid #E2E8F0' }}>
                <h4 style={{ fontSize: '14px', marginBottom: '10px', color: '#334155' }}>Sub-Category Display Settings</h4>

                <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Card Style</label>
                    <select className="modern-input" value={subCategoryStyle} onChange={(e) => setSubCategoryStyle(e.target.value)}>
                      <option value="style_1">Style 1 (Fashion Circles)</option>
                      <option value="style_2">Style 2 (Beauty Wide)</option>
                      <option value="style_4">Style 4 (Fresh Square)</option>
                      <option value="style_5">Style 5 (Pharma Grey)</option>
                      <option value="style_7">Style 7 (Pills)</option>
                      <option value="style_8">Style 8 (Tall Portrait)</option>
                      <option value="style_10">Style 10 (Minimal Outline)</option>
                      <option value="style_21">Style 21 (Polaroid)</option>
                      <option value="style_29">Style 29 (Coupon)</option>
                      <option value="style_34">Style 34 (Chat Bubble)</option>
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Alignment</label>
                    <select className="modern-input" value={headingAlignment} onChange={(e) => setHeadingAlignment(e.target.value)}>
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                </div>

                <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Section BG</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={subCategorySectionBg} onChange={(e) => setSubCategorySectionBg(e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Card BG</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={subCategoryCardBg} onChange={(e) => setSubCategoryCardBg(e.target.value)} />
                  </div>
                </div>

                <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Text Color</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={subCategoryTextColor} onChange={(e) => setSubCategoryTextColor(e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Accent Color</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={subCategoryAccentColor} onChange={(e) => setSubCategoryAccentColor(e.target.value)} />
                  </div>
                </div>

                <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 2 }}>
                    <label className="form-label">Top Text (Small)</label>
                    <input type="text" className="modern-input" value={headingTopText} onChange={(e) => setHeadingTopText(e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Color</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={headingTopColor} onChange={(e) => setHeadingTopColor(e.target.value)} />
                  </div>
                </div>

                <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 2 }}>
                    <label className="form-label">Main Title</label>
                    <input type="text" className="modern-input" value={headingMainText} onChange={(e) => setHeadingMainText(e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Color</label>
                    <input type="color" className="modern-input" style={{ padding: '0', height: '40px', width: '100%', border: 'none', borderRadius: '12px' }} value={headingMainColor} onChange={(e) => setHeadingMainColor(e.target.value)} />
                  </div>
                </div>
              </div>

              <div className="form-group"><label className="form-label">Icon Thumbnail</label><input type="file" id="mainImageInput" className="modern-input" accept="image/*" onChange={(e) => setMainImage(e.target.files[0])} style={{ padding: '10px' }} /></div>
              <div className="form-group"><label className="form-label">Theme Background (Optional)</label><input type="file" id="topImageInput" className="modern-input" accept="image/*" onChange={(e) => setTopImage(e.target.files[0])} style={{ padding: '10px' }} /></div>
              <div className="form-group"><label className="form-label">UI Banner Image (Optional)</label><input type="file" id="bannerImageInput" className="modern-input" accept="image/*" onChange={(e) => setBannerImage(e.target.files[0])} style={{ padding: '10px' }} /></div>

              <button type="submit" disabled={isMainLoading} className="modern-btn">{isMainLoading ? 'Saving...' : 'Publish Root Category'}</button>
            </form>
          </div>

          <div className="pd-form-widget">
            <h3 className="pd-widget-title">🛍️ Add Sub-Category</h3>
            <form onSubmit={handleAddSubCategory}>
              <div className="form-group">
                <label className="form-label">Select Parent</label>
                <select className="modern-input" value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)}>
                  <option value="">-- Choose Category --</option>
                  {categories.map(cat => <option key={cat._id} value={cat._id}>{cat.name}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Name</label><input type="text" className="modern-input" value={subCatName} onChange={(e) => setSubCatName(e.target.value)} placeholder="e.g. Laptops" /></div>
              <div className="form-group"><label className="form-label">Thumbnail</label><input type="file" id="subCatImageInput" className="modern-input" accept="image/*" onChange={(e) => setSubCatImage(e.target.files[0])} style={{ padding: '10px' }} /></div>
              <div className="form-group">
                <label className="form-label">Bind Attributes</label>
                <div className="pd-pill-checkboxes">
                  {globalAttributes.length === 0 && <span style={{ fontSize: '12px', color: '#888' }}>No attributes found.</span>}
                  {globalAttributes.map(attr => (
                    <label key={attr._id} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', background: '#fff', padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontWeight: '600' }}>
                      <input type="checkbox" checked={selectedAttributes.includes(attr.name)} onChange={() => handleCheckboxChange(attr.name)} /> {attr.name}
                    </label>
                  ))}
                </div>
              </div>
              <button type="submit" disabled={isSubLoading} className="modern-btn" style={{ background: 'var(--brand-blue)' }}>{isSubLoading ? 'Saving...' : '+ Bind Sub-Category'}</button>
            </form>
          </div>
        </div>

        <div className="pd-gallery-container">
          {isFetching ? <div className="loader-container"><div className="spinner"></div></div> : categories.length === 0 ? <div className="pd-main-card" style={{ textAlign: 'center', padding: '50px' }}>No Categories Found.</div> : (
            categories.map((cat) => (
              <div key={cat._id} className="pd-main-card">
                <div className="pd-main-card-header">
                  <div className="pd-main-profile">
                    <img src={`https://pickupdrop.dodigitals.in/${cat.image}`} alt={cat.name} onError={(e) => e.target.src = 'https://via.placeholder.com/70'} />
                    <div>
                      <h3>{cat.name}</h3>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span>{cat.subCategories?.length || 0} Sub-categories</span>
                        <div style={{ display: 'flex', gap: '4px' }} title="Theme Colors">
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: cat.themeDarkBg || '#4C1D95', border: '1px solid #e2e8f0' }}></span>
                          <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: cat.themeLightBg || '#F3E8FF', border: '1px solid #e2e8f0' }}></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pd-main-actions">
                    <button onClick={() => openEditModal('main', cat)} className="pd-btn-icon">✏️</button>
                    <button onClick={() => handleDeleteMainCategory(cat._id)} className="pd-btn-icon delete">🗑️</button>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '10px', padding: '0 15px', marginBottom: '10px' }}>
                  {cat.themeTopImage && (
                    <div style={{ flex: 1 }}>
                      <p style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>Theme BG:</p>
                      <img src={`https://pickupdrop.dodigitals.in/${cat.themeTopImage}`} alt="Theme BG" style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0' }} />
                    </div>
                  )}
                  {cat.bannerImage && (
                    <div style={{ flex: 1 }}>
                      <p style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>UI Banner:</p>
                      <img src={`https://pickupdrop.dodigitals.in/${cat.bannerImage}`} alt="UI Banner" style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0' }} />
                    </div>
                  )}
                </div>

                <div style={{ padding: '10px 15px', background: '#F8FAFC', margin: '0 15px 15px', borderRadius: '8px', fontSize: '12px' }}>
                  <span style={{ fontWeight: 'bold', color: '#475569' }}>Style:</span> {cat.subCategoryStyle || 'style_4'} |
                  <span style={{ fontWeight: 'bold', color: '#475569', marginLeft: '10px' }}>Align:</span> {cat.headingAlignment || 'left'} <br />
                  <span style={{ color: cat.headingTopColor || '#94A3B8', fontWeight: 'bold' }}>{cat.headingTopText || 'DISCOVER'}</span> <br />
                  <span style={{ color: cat.headingMainColor || '#0F172A', fontWeight: 'bold', fontSize: '14px' }}>{cat.headingMainText || cat.name}</span>
                  <br />
                  <span style={{ fontWeight: 'bold', color: '#475569' }}>Section BG:</span> {cat.subCategorySectionBg || '#FFFFFF'} <br />
                  <span style={{ fontWeight: 'bold', color: '#475569' }}>Card BG:</span> {cat.subCategoryCardBg || '#F8FAFC'} <br />
                  <span style={{ fontWeight: 'bold', color: '#475569' }}>Text:</span> {cat.subCategoryTextColor || '#334155'} |
                  <span style={{ fontWeight: 'bold', color: '#475569', marginLeft: '8px' }}>Accent:</span> {cat.subCategoryAccentColor || '#E11D48'}
                </div>

                <div className="pd-sub-gallery">
                  {cat.subCategories && cat.subCategories.length > 0 ? cat.subCategories.map((sub, i) => (
                    <div key={i} className="pd-sub-item">
                      <div className="pd-sub-head">
                        <img src={`https://pickupdrop.dodigitals.in/${sub.image}`} alt="sub" onError={(e) => e.target.src = 'https://via.placeholder.com/40'} />
                        <span>{sub.name}</span>
                      </div>
                      <div className="pd-sub-attrs">
                        {sub.attributes && sub.attributes.length > 0 ? sub.attributes.map((attr, idx) => (
                          <span key={idx} className="pd-attr-tag">{attr}</span>
                        )) : <span style={{ fontSize: '11px', color: '#999', fontStyle: 'italic' }}>No attributes</span>}
                      </div>
                      <div className="pd-sub-actions">
                        <button onClick={() => openEditModal('sub', { ...sub, categoryId: cat._id })} className="pd-sub-action-btn">✏️</button>
                        <button onClick={() => handleDeleteSubCategory(cat._id, sub._id)} className="pd-sub-action-btn" style={{ color: '#ef4444' }}>×</button>
                      </div>
                    </div>
                  )) : <div style={{ color: '#999', fontSize: '13px', padding: '10px' }}>No sub-categories linked yet.</div>}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryManagement;